import React, { useState } from 'react';

import { Typography } from '@mui/material';

import { Container, Content, SummaryTextField, GenerateButton } from './styles';
import api from '../../services/api';
import SurveySummary from '../Questionnaire/SurveySummary';

const RecoverySummary: React.FC = () => {
  const [text, setText] = useState('');
  const [survey, setSurvey] = useState<any>();
  const [results, setResults] = useState<any>();
  const [summaryExists, setSummaryExists] = useState<boolean>();

  const handleGenerate = async (): Promise<void> => {
    const response = await api.get(`/results/surveyAndResult/${text}`);
    const { survey: surveyData, results: resultsData } = response.data;

    console.log(resultsData);

    if (!surveyData || !resultsData) {
      setSurvey(undefined);
      setResults(undefined);
      setSummaryExists(undefined);
      return;
    }

    // The Survey document uses `surveyId`, but SurveySummary (and the
    // summary config route) expect `idSurvey`, following the same rename
    // done for `access.survey` in the Questionnaire page.
    const { surveyId } = surveyData;

    const summaryResponse = await api.get(`/surveySummary/survey/${surveyId}`);
    const hasSummary = summaryResponse.data.length > 0;

    setSurvey({ ...surveyData, idSurvey: surveyId });
    setResults(resultsData);
    setSummaryExists(hasSummary);
  };

  return (
    <Container>
      <Typography variant="h4">Recovery Summary</Typography>

      <Content>
        <SummaryTextField
          fullWidth
          size="small"
          label="Text"
          value={text}
          onChange={e => setText(e.target.value)}
        />

        <GenerateButton variant="contained" onClick={handleGenerate}>
          Generate
        </GenerateButton>
      </Content>

      {summaryExists === false && (
        <Typography sx={{ marginTop: 2 }}>
          Does not exist summary for this survey
        </Typography>
      )}

      {summaryExists === true && survey && results && (
        <SurveySummary survey={survey} results={results} />
      )}
    </Container>
  );
};

export default RecoverySummary;
